export enum ListingOwnershipTexts {
    Coop = 'COOP',
    Condo = 'CONDO',
    Condop = 'CONDOP',
    Townhouse = 'TOWNHOUSE',
    Rental = 'RENTAL'
}